require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/fn/object/assign.js
// module id = 328
// module chunks = 0